import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';

import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { PackageInstructionItem, ApprovalBE, PkgInstrPruRelationBE } from './shared/packaging-instruction.model';

@Injectable()
export class PackageInstructionService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'PackaginInstruction';
    private apiNotImplementedUrl: string = this.config.get('apiUrl') + 'NotImplementedYet';

    getInstruction(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPackageInstructionFor/?packInstructionId=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteInstruction(id: number, deleteMessage: string, userId: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeletePackagingInstruction?packInstructionId=${id}&deleteMessage=${deleteMessage}&userId=${userId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    saveInstruction(instruction: PackageInstructionItem): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(instruction);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/SavePackagingInstruction`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    sendPackagingInstructionForApproval(approvalBE: ApprovalBE): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(approvalBE);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/SendPackagingInstructionForApproval`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getInstructionList(searchTerm: string, supplierNumber: string, extendedSupplierNumber: string, isSupplier: boolean, instructionType: number): Observable<IReturnObject> {
        let url = `${this.apiUrl}/GetPackageInstructionList/?searchTerm=${searchTerm}`
            + `&supplierNumber=` + supplierNumber
            + `&extendedSupplierNumber=` + extendedSupplierNumber
            + `&isSupplier=` + isSupplier;
            + `&instructionType=` + instructionType;
        return this.http.get(url)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getLevelConstraintData(constraintCodeId: number, mainCodeId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetLevelConstraintData/?constraintCodeId=${constraintCodeId}&mainCodeId=${mainCodeId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getNewLevelInfoFor(codeId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetNewLevelInfoFor/?codeId=${codeId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getPreviewPdf(id: number, piName: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/GetPreviewPdf/?piId=${id}&piName=${piName}`);
        //.map((response: Response) => response.json());
    }

    piNameExist(piName: string): Observable<boolean> {
        return this.http.get(`${this.apiUrl}/PiNameExist/?piName=${piName}`)
            .map((response: Response) => <boolean>response.json());
    }

    GetPiName(piName: string, id: number): Observable<string> {
        return this.http.get(`${this.apiUrl}/GetPiName/?piName=${piName}&piId=${id}`)
            .map((response: Response) => <string>response.json());
    }

    getPruList(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPruList`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    scrapPkgInstr(pkgInstrId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/ScrapPkgInstr/?pkgInstrId=${pkgInstrId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    UncheckPruRelationforPi(pkgInstrPruRelationBE: PkgInstrPruRelationBE, piname: string): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(pkgInstrPruRelationBE);
        var bodyUpdated = JSON.parse(body);
        bodyUpdated['piname'] = piname;
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/UncheckPruRelationforPi`, body, options)
            .map((response: Response) => <IReturnObject>response.json());

    }

    UncheckPruRelation(pkgInstrPruRelationBE: PkgInstrPruRelationBE): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(pkgInstrPruRelationBE);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(`${this.apiUrl}/UncheckPruRelation`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    isFirstPIWithPnl(instruction: PackageInstructionItem): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(instruction);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(`${this.apiUrl}/IsFirstPIWithPnl`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    isFirstPIWithSl(instruction: PackageInstructionItem): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(instruction);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(`${this.apiUrl}/IsFirstPIWithSl`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }
    isFirstPIWithCPC(instruction: PackageInstructionItem): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(instruction);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(`${this.apiUrl}/IsFirstPIWithCPC`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    checkConflict(instruction: PackageInstructionItem): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(instruction);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(`${this.apiUrl}/CheckConflict`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    // postIt(url: string, data: any): Observable<IReturnObject> {
    //     let headers: Headers = new Headers();
    //     headers.append('Content-Type', 'application/json');
    //     headers.append('Accept', 'application/json');
    //     let body = JSON.stringify(data);
    //     let options = new RequestOptions({ headers: headers });

    //     return this.http.post(url, body, options)
    //         .map((response: Response) => <IReturnObject>response.json());
    // }
}




// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/packaging-instruction/packaging-instruction.service.ts